import { createStandardAction } from 'typesafe-actions';
import { ClassDigitalNotebookSelected } from './type';

export const setClassDigitalNotebookSelected = createStandardAction(
  'CLASSDIGITALNOTEBOOK/SELECTED'
)<ClassDigitalNotebookSelected>();
